import http from '@/communication/AuthConnection'

export default async ({ commit, state }, params) => {
  try {
    const { data } = await http.get(`/v1/document-type`, {params})
    commit('SET_LIST', data.result)
  } catch (error) {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/brain/record/document-type/list-paginated/index.js